import * as React from 'react';
export const mypbSvg = React.forwardRef(function mypbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.5 4h-8L6 9.5v5.75l.75.75-.75.75v6L11.5 28h8.25L25 22.75v-6l-.75-.75.75-.75V9.5L19.5 4Z',
      fill: '#EB2027',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm22.25 19.6-6.75 6.75-6.75-6.75.75-.75 2 2h8l2-2 .75.75Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.75 16-3.25 3.25L12.25 16l3.25-3 3.25 3Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm22.25 12.6-.75.75-2-2h-8l-2 2-.75-.75 6.75-6.75 6.75 6.75Z',
      fill: '#fff',
    }),
  );
});
mypbSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var mypb = {
  category: 'brand',
  colorable: false,
  name: 'mypb',
  svg: mypbSvg,
};
